<template>
  <div class="all-systems">
    <div class="status" :class="statusClass" v-text="statusText"></div>
  </div>
</template>

<script>
export default {
  props: {
    monitors: {
      type: Array,
      required: true,
    },
  },
  computed: {
    stateUp() {
      return this.monitors.filter((item) => item.meta.attributes.state === 10)
        .length;
    },
    stateDown() {
      return this.monitors.filter((item) => item.meta.attributes.state === -10)
        .length;
    },
    stateUnknown() {
      return this.monitors.filter((item) => item.meta.attributes.state === 0)
        .length;
    },
    count() {
      return this.monitors.length;
    },
    statusClass() {
      if (this.stateDown && this.stateDown < this.count) {
        return "warning";
      }
      if (this.stateDown === this.count) {
        return "outage";
      }
      if (this.stateUp) {
        return "operational";
      }
      return "disabled";
    },
    statusText() {
      if (this.stateDown && this.stateDown < this.count) {
        return "Partial Outage In Progress";
      }
      if (this.stateDown === this.count) {
        return "Major Outage In Progress";
      }
      if (this.stateUp) {
        return "All Services Operational";
      }
      return "Monitoring Disabled";
    },
  },
};
</script>

<style lang="scss" scoped>
.all-systems {
  padding: 1rem 0.5rem;
  text-align: center;
  .status {
    padding: 1rem;
    text-transform: uppercase;
    border-radius: 5px;
    font-weight: bold;
  }
}
</style>
